import { useTranslation } from 'react-i18next';
import { Col } from '../../col';
import { GroupLineIcon } from '../../icons';
import { Row } from '../../row';
import { Text } from '../../typography';
import { useFormatMembersCount } from './hooks';

type P = {
  membersCount: number;
};

const MembersCount = ({ membersCount }: P) => {
  const { t } = useTranslation();
  const formattedMembersCount = useFormatMembersCount({ count: membersCount });

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        <GroupLineIcon size="extra-small" />
      </Col>
      <Col>
        {/* TODO: resolve count under 10, count is updated daily, if i join and memebers is under 10, it will be not shown rigth away, something like 1+ would be better */}
        <Text>
          {t('formattedMembersCount', {
            count: membersCount,
            formattedCount: formattedMembersCount,
          })}
        </Text>
      </Col>
    </Row>
  );
};

export default MembersCount;
